export class BaseModifier {
    constructor(selector) {
        this.selector = selector;
    }
    get input() {
        return this._input;
    }
    set input(value) {
        this._input = value;
        this.initialize();
    }
}
